"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function camelToKebab(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
exports.default = camelToKebab;
//# sourceMappingURL=camelToKebab.js.map